import React from "react";
import { components } from "../../../../../api/spec";

interface PreparingSetupsListProps {
  candidates: components["schemas"]["EventCandidateSummarySchema"][];
  isDisabled: boolean;
  onDisqualifyClicked: (candidate: string) => void;
}

const PreparingSetupsList: React.FC<PreparingSetupsListProps> = ({
  candidates,
  isDisabled,
  onDisqualifyClicked,
}) => (
  <div className="mb-8 divide-y divide-white/20">
    {candidates.map((candidate) => (
      <div
        key={candidate.guid}
        className="flex items-center justify-between bg-black/30 backdrop-blur-sm py-3 px-4"
      >
        <div className="flex-1">
          <h3 className="text-white font-medium text-md">
            {candidate.user_1_full_name} & {candidate.user_2_full_name}
          </h3>
          {candidate.is_manually_created && (
            <p className="text-white/60 text-sm mt-1">Manual setup</p>
          )}
        </div>
        <button
          type="button"
          disabled={isDisabled}
          onClick={() => onDisqualifyClicked(candidate.guid!)}
          className={isDisabled ? "opacity-50 cursor-not-allowed" : ""}
        >
          ❌
        </button>
      </div>
    ))}
  </div>
);

export default PreparingSetupsList;
